import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Biography from "./components/Biography";
import Milestones from "./components/Milestones";
import Gallery from "./components/Gallery";
import BlogPage from "./pages/BlogPage";
// NEW
import Footer from "./components/footer";
import Contact from "./components/GetInTouch";
import GalleryPage from "./pages/GalleryPage";
import AcademicInsights from "./components/AcademicInsights";
import ProtectedRoute from "./admin/ProtectedRoute";
import Admin from "./admin/Admin";
import Login from "./admin/Login";
import { Routes, Route } from "react-router-dom";
import BlogDetail from "./pages/BlogDetail";
import AdminContacts from "./pages/AdminContacts";

function App() {
  return (
    <>
      <Navbar />

      <Routes>

        {/* HOME PAGE */}
        <Route
          path="/"
          element={
            <>
              <Hero />
              <Biography />
              <Milestones />
              <Gallery />
              <AcademicInsights/>
              <Contact/>
              <Footer/>
            </>
          }
        />

        {/* FULL GALLERY PAGE */}
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/blog/:id" element={<BlogDetail />} />

 <Route path="/blogs" element={<BlogPage />} />
 <Route path="/login" element={<Login />} />
  <Route path="/allenquiries" element={<AdminContacts />} />


  <Route
    path="/admin"
    element={
      <ProtectedRoute>
        <Admin />
      </ProtectedRoute>
    }
  />
      </Routes>
    </>
  );
}

export default App;